// export const DonorURL = 'http://localhost:3010/';

export const DonorURL = 'http://donatur.sandra-dev.dompetdhuafa.org/api/';

